var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page article-page scrollbar-style" },
    [
      _vm.items.length > 0
        ? _c("CoolLightBox", {
            attrs: { items: _vm.items, index: _vm.index, effect: "swipe" },
            on: {
              close: function($event) {
                _vm.index = null
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item
        ? _c(
            "div",
            { staticClass: "container", staticStyle: { height: "100%" } },
            [
              _c("div", { staticClass: "grid" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "cell-sm-full cell-md-10" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.item.title))]),
                    _vm._v(" "),
                    _c("h5", [_vm._v("Γιώργος Γκιζάρης")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          cursor: "pointer",
                          color: "yellow",
                          "font-size": "14px"
                        },
                        on: {
                          click: function() {
                            this$1.$router.push("/")
                          }
                        }
                      },
                      [_c("span", { staticClass: "mif-backspace mif-2x" })]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell-full" }, [
                    _c(
                      "div",
                      { staticStyle: { color: "#aaa", "font-size": "14px" } },
                      [
                        _vm._v(
                          "\r\n                    " +
                            _vm._s(_vm.item.description) +
                            "\r\n                "
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("vue-masonry-gallery", {
                attrs: { imgsArr: _vm.images },
                on: { click: _vm.onImgClick }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "cell-sm-full cell-md-2",
        staticStyle: { "font-size": "12px" }
      },
      [
        _c("div", [_c("strong", [_vm._v("Τηλ:")]), _vm._v("  6976359583")]),
        _vm._v(" "),
        _c("div", [
          _c("strong", [_vm._v("Email:")]),
          _vm._v("  gguizaris@hotmail.com")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }